<template>
  <div>
    <b-row>
      <b-col sm="12">
        <InputText
          title="Nome"
          field="name"
          :formName="formName"
          :required="true"
          :maxLength="40"
          v-model="typeRental.name"
          :markFormDirty="false"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <div class="text-right">
          <Button
            _key="btnSaveTypeRental"
            type="success"
            title="Salvar"
            :disabled="!isFormValid(formName)"
            classIcon="fas fa-save"
            size="medium"
            :clicked="saveTypeRental"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import TypeRent from "@/components/modules/rental/type-rent/TypeRent.js";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "TypeRentCreateUpdate",
  props: {
    registerInSelect: Boolean,
    value: Object,
  },
  components: { InputText, Button },
  data() {
    return {
      formName: "typeRentalCreateUpdate",
      typeRental: new TypeRent(),
      urlCreate: "/api/v1/rental/type-rent/create",
      urlUpdate: "/api/v1/rental/type-rent/update",
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapActions("generic", ["postApi", "putApi"]),
    ...mapMutations("generic", [
      "removeLoading",
      "removeEvent",
      "hideModal",
      "hideVodal",
    ]),
    ...mapMutations("validation", ["resetValidation"]),
    saveTypeRental() {
      if (this.typeRental.id) {
        let params = { url: this.urlUpdate, obj: this.typeRental };
        this.putApi(params).then((response) => {
          if (response.success && !this.registerInSelect) this.hideModal();
          this.removeLoading(["btnSaveTypeRental"]);
        });
      } else {
        let params = { url: this.urlCreate, obj: this.typeRental };
        this.postApi(params).then((response) => {
          if (response.success && !this.registerInSelect) this.hideModal();
          if (response.success && this.registerInSelect) {
            this.$emit("input", {
              id: response.content.id,
              content: response.content.name,
            });
           this.hideVodal(this.formName);;
          }
          this.removeLoading(["btnSaveTypeRental"]);
        });
      }
    },
    update(data) {
      this.typeRental = new TypeRent();
      this.typeRental.update(data);
      this.removeLoading([data.id]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "typeRentalCreate") {
          this.resetValidation(this.formName);
          this.typeRental = new TypeRent();
        }
        if (event.name == "typeRentalUpdate") this.update(event.data);
      },
      deep: true,
    },
  },
};
</script>
